import { makeStyles } from '@material-ui/core';

export const useTileStyles = makeStyles((theme) => ({
  tile: (props) => ({
    backgroundImage: props.backgroundImage
      ? `url(${props.backgroundImage})`
      : 'none',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    alignItems: 'center',
    '&:hover': {
      WebkitFilter: 'brightness(90%)',
      msFilter: 'brightness(90%)',
      filter: 'brightness(90%)',
      '& svg': {
        transform: 'scale(1.1)',
      },
    },
    padding: '1rem',
  }),
  rightIconText: { textTransform: 'uppercase' },
  svgIcon: (props) => ({
    color: props.iconColor ? props.iconColor : 'initial',
  }),
}));
